export const texts = {
  title: {
    de: 'Nicht registriert',
    en: 'Not registered'
  },
  message: {
    de: 'Die Anmeldung war leider nicht möglich. Bitte wenden Sie sich an Ihren Ansprechpartner bei skillconomy, um einen Link zur Registrierung im Portal zu erhalten!',
    en: 'Unfortunately sign in was not possible. Please contact your skillconomy representative to receive a link to register in the portal!'
  },
  mailtoHref: {
    de: 'mailto:info@skillconomy.com?subject=Anfrage Registrierungslink&body=Bitte senden Sie mir einen Link zur Registrierung im skillconomy-Portal an ',
    en: 'mailto:info@skillconomy.com?subject=Registration link request&body=Please send me a link to register in the skillconomy portal at '
  },
  requestLink: {
    de: 'Link anfragen',
    en: 'Request link'
  },
  hasAccount: {
    de: 'Sie haben bereits einen Account?',
    en: 'Already have an account?'
  },
  signIn: {
    de: 'Anmelden',
    en: 'Sign in'
  }
};
